/* eslint-disable */
import colors from '../../../../../public/colors'


export default theme => {
    const { mode } = theme.palette
    return {
    buttonContainer: {
        display: 'flex',
        justifyContent: 'end',
        gap:'2%',
        width: '100%'
    },
    backButton: {
        '&.MuiButton-root': {
            border: `1px solid ${colors[mode].primaryText}`,
            borderRadius: '2px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            color: colors[mode].primaryText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '12px',
            fontWeight: 400,
            height: '32px',
            letterSpacing: '0.46px',
            lineHeight: '16px',
            marginLeft: '10px',
            padding: '8px 16px',
            textTransform: 'uppercase',
            width: 'auto',        
        },
        '&:disabled': {
            borderColor: 'rgba(0, 0, 0, 0.12)'
        }
    },
    nextButton: {
        '&.MuiButton-root': {
            backgroundColor: '#FEDF01',
            borderRadius: '2px',
            boxSizing: 'border-box',
            boxShadow: 'none',
            color: '#003168',
            height: '32px',
            width: 'auto',
            padding: '8px 16px'
        }
    },
    nextButtonDisabled: {
        '&.MuiButton-root': {
            opacity: '50%'
        }
    },
    introText: {
        paddingLeft: '24px',
        paddingRight: '24px',
        marginTop: '5%',
        marginBottom: '5%',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '16px',
            paddingRight: theme.spacing(1),
            paddingTop: '16px'
        }
    },
    radio: {
        '&.Mui-checked': {
            color: colors[mode].cardImageTextRBCHover
        },
        color: colors[mode].verificationCodeLabel,
        marginRight: '10px'
    },
    accountRecoveryOption: {
        '&:hover': {
            backgroundColor: colors[mode].skeletonInsightsBackground,
            border: `1px solid ${colors[mode].recoveryBorder}`,
            color: '#003168',
            cursor: 'pointer',
            opacity: 0.9
        },
        alignItems: 'center',
        border: `1px solid ${colors[mode].welcomeCardBorder}`,
        borderRadius: '2px',
        display: 'flex',
        flexDirection: 'row',
        fontFamily: 'Roboto',
        height: '74px',
        justifyContent: 'space-between',
        maxWidth: '602px',
        width: '602px',
        marginBottom: '3%',
        [theme.breakpoints.down('md')]: {
            width: '95%'
        },
        [theme.breakpoints.down('sm')]: {
            width: '95%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '90%'
        }
    },
    iconDesc: {
        color: colors[mode].mfaActiveBackground,   
        fontSize: '1.25rem',
        fontWeight: '500'
    },
    link: {
        textDecorationColor : '#606AC3'
    },
    helpText: {
        fontStyle: 'italic',
            margin: 0,
            marginBottom: '5%',
    padding: '0px 0px 24px 35px',
        [theme.breakpoints.down('md')]: {
            padding: '7px 24px'
        },
        [theme.breakpoints.down('sm')]: {
            padding: '0px 24px 0px 24px',
        }
    },
    cardItem:{
        width: '245px',
    display: 'flex',
    gap: '15px',
    background: '#F8F9FB',
    cursor: 'pointer',
    border: '1px solid #003168',
        justifyContent: 'center',
    marginBottom: '7%',
    },
    selectedCardItem: {
        backgroundColor: colors[mode].skeletonInsightsBackground,
        border: `1px solid ${colors[mode].recoveryBorder}`,
        color: '#003168',
    },
    cancelButton: {
        '&.MuiButton-root': {
            backgroundColor: '#FFFFFF',
            boxShadow: 'none',
            color: '#003168',
            height: '32px',
            marginLeft: '7px',
            width: '80px'
        }
    },
    verbiage: {
        fontSize: '0.875rem',
        color: colors[mode].cardDescription,
        lineHeight: '20px'
    },
    setupIcon: {
        marginBottom: '10%'
    },
    content: {
        fontSize: '24px',
        fontWeight: '500'
    },
    contentContainer: {
        borderRadius: '3px',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    download: {
        color: 'rgba(0,0,0,0.54)',
        fontSize: '16px',
        fontWeight: '300',
        letterSpacing: '0',
        lineHeight: '24px',
        paddingTop: '24px'
    },
    downloadLink: {
        fontSize: '16px',
        fontWeight: '300',
        letterSpacing: '0',
        lineHeight: '24px',
    },

    loader: {
        height: '100%',
        left: '0',
        position: 'absolute',
        top: '0',
        width: '100%',
        'z-index': '10'
    },
    root: {
        padding: theme.spacing(0, 2, 2, 2)
    },
    italics: {
        fontStyle: 'italic'
    },
    subTitle: {
        color: colors[mode].cardDescription,
        fontSize: '0.875rem',
        letterSpacing: '0.17px',
        lineHeight: '1.25rem'
    },
    helpText: {
        fontStyle: 'italic',
            margin: 0
    },
    accountRecoveryInfo: {
        display: 'flex',
        gap: '8px',
        justifyContent: 'space-evenly',
        paddingLeft: '15px',
        [theme.breakpoints.down('sm')]: {
            gap: '0px',
        }
    },
    footerContainer: {
        display: 'grid',
        gridTemplateColumns: '2.5fr 1fr',
        /* margin-left: 8%; */
        justifyContent: 'center',
    },
    firstColumn:{
        alignSelf: 'start',
        display: 'grid',
        gap: '7px',
        paddingLeft: '55px !important'
    }
}}
